/*= ========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */
import { withTenantKey } from '@/libs/storageKeys'

const defaultUser = {
  id: '',
  email: '',
  username: '',
  name: '',
  surname: '',
  position: '',
  roles: [],
  teamLoginOnly: false,
  requirePasswordChange: false,
}

const defaultUserTeam = {
  id: '',
  status: true,
  currentOrder: {},
  teamDefinition: {
    id: '',
    code: '',
  },
  vehicle: {
    id: '',
    brand: '',
    model: '',
    registrationNumber: '',
    sideNumber: '',
    status: '',
    fuelCostPerOneKm: 0,
    additionalCostsDaily: 0,
  },
  driverUser: {
    id: '',
    name: '',
    surname: '',
    position: '',
  },
  paramedicUser: null,
  teamStartedAt: '',
  checklistConfirmedAt: null,
}

const getUserTokens = () => JSON.parse(localStorage.getItem(withTenantKey('tokens'))) || {}

const getUserInfo = () => {
  const userInfo = {}

  Object.keys(defaultUser).forEach(key => {
    userInfo[key] = defaultUser[key]
  })

  return userInfo
}

export default {
  twoFactorAuthenticationInProgress: false,
  activeUser: getUserInfo(),
  activeUserTokens: getUserTokens(),
  userTeam: defaultUserTeam,
  defaultUserTeam,
  showInitTeamPopup: false,
  teamLoaded: false,
  notifications: [],
  isUserLoggedIn: () => !!localStorage.getItem(withTenantKey('userInfo')) && !!localStorage.getItem(withTenantKey('tokens')),
}
